import React from "react";
import { Button, Text, Flex, Spacer, Heading } from "@badi/badi-components";

import { translate } from "base/shared/Localization";
import Image from "components/Image/Image";
import { FeedbackWrapper } from "./styled-components";
import FindOutMoreAboutFastTrack from "./find-out-more-about-fast-track";

const FeedbackWithFastTrackInfo = ({
  onContinue = null,
  onFastTrackFindOutMoreClick,
}) => {
  const handleClick = () => {
    if (onContinue) onContinue();
  };
  return (
    <>
      <FeedbackWrapper alignItems="center" as={Flex} justify="center">
        <Flex alignItems="center" direction="column">
          <Image src="/assets/images/message-enquiry-sent.svg" />
          <Spacer bottom={1}>
            <Heading
              data-qa="message-enquiry-educational-title"
              level="24-Bold"
            >
              {translate("enquiry.feedback.title")}
            </Heading>
          </Spacer>
          <Text center={true} dataQa="message-enquiry-educational-description">
            {translate("enquiry.feedback.description")}
          </Text>
        </Flex>
      </FeedbackWrapper>
      {onContinue && (
        <Spacer top={1}>
          <Button
            data-qa="message-enquiry-educational-button"
            fullWidth={true}
            onClick={handleClick}
          >
            {translate("contact.flow.stepper_cta_continue")}
          </Button>
        </Spacer>
      )}
      <FindOutMoreAboutFastTrack
        onClick={onFastTrackFindOutMoreClick}
        inverted
      />
    </>
  );
};

export default FeedbackWithFastTrackInfo;
